module.exports = __webpack_public_path__ + "img/trans-subbg.e4d1d961.jpg";